/*
 * Show only the selected colour's photos on a product page.
 *
 * Shopify allows one image per variant, so the built-in behaviour can only
 * jump the gallery to a single photo - every other colour's shots stay on the
 * page. This filters the gallery instead.
 *
 * A photo's colour is read from its filename, which is how the shoot files are
 * already named: gallery-coat-ivory-3.jpg, aubrey-stand-collar-onyx-1.jpg.
 * Shopify appends a uuid on a re-upload (…-ivory-1_3f989407-….jpg); the colour
 * token still matches.
 *
 * Deliberately does nothing when it cannot be sure:
 *  - no Colour option, or no photo matches the selected colour -> show all.
 * An unfiltered gallery is the current behaviour. A blank one is a broken page.
 */
(function () {
  'use strict';

  var COLOUR_OPTION = /^colou?r$/i;

  function slug(value) {
    return String(value)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  /* "Onyx Grain" is the option value but the files are named …-onyx-N.jpg, so
     the full slug is tried first and the leading word second. Every product's
     colours differ in their first word, so this cannot cross-match. */
  function tokensFor(value) {
    var full = slug(value);
    var first = full.split('-')[0];
    return full === first ? [full] : [full, first];
  }

  /* Filename AND alt text, because not every shot is named after its colour.
     Where the upload carries a name like NAATKA_ECOM10075.jpg, typing the
     colour into the image's alt text in the admin is enough to group it - and
     alt text is worth having on a product photo anyway. */
  function sourceOf(item) {
    var img = item.querySelector('img');
    if (img) {
      return (
        (img.getAttribute('src') || img.getAttribute('srcset') || '') +
        ' ' +
        (img.getAttribute('alt') || '')
      ).toLowerCase();
    }
    var media = item.querySelector('[src], [data-src]');
    return media ? (media.getAttribute('src') || media.getAttribute('data-src') || '').toLowerCase() : '';
  }

  function colourInput(scope) {
    var inputs = scope.querySelectorAll('input[data-option-name], select[data-option-name]');
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      if (!COLOUR_OPTION.test(el.dataset.optionName || '')) continue;
      if (el.tagName === 'SELECT') return el.value;
      if (el.checked) return el.value;
    }
    return null;
  }

  /* Every colour the product sells, so a photo can be attributed to one colour
     rather than merely tested against the selected one. Without this, picking
     "Onyx" on a product whose files are named "onyx" and "onyx-grain" would
     keep both. */
  function allColours(scope) {
    var out = [];
    var inputs = scope.querySelectorAll('input[data-option-name], select[data-option-name] option');
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      var name = el.dataset.optionName || (el.parentElement && el.parentElement.dataset.optionName) || '';
      if (!COLOUR_OPTION.test(name)) continue;
      var value = el.value;
      if (value && out.indexOf(value) === -1) out.push(value);
    }
    return out;
  }

  function colourOfSource(src, colours) {
    var best = null;
    var bestLength = 0;
    for (var i = 0; i < colours.length; i++) {
      var tokens = tokensFor(colours[i]);
      for (var t = 0; t < tokens.length; t++) {
        /* The longest matching token wins, so "onyx-grain" beats "onyx". */
        if (src.indexOf(tokens[t]) !== -1 && tokens[t].length > bestLength) {
          best = colours[i];
          bestLength = tokens[t].length;
        }
      }
    }
    return best;
  }

  function apply(section) {
    var gallery = section.querySelector('media-gallery');
    var picker = section.querySelector('variant-selects') || section;
    if (!gallery) return;

    var selected = colourInput(picker);
    var items = gallery.querySelectorAll('.product__media-item');
    if (!selected || !items.length) return;

    var colours = allColours(picker);
    var wanted = [];
    var hidden = [];

    for (var i = 0; i < items.length; i++) {
      var owner = colourOfSource(sourceOf(items[i]), colours);
      if (owner === null) continue; // unattributable - always keep
      (owner === selected ? wanted : hidden).push(items[i]);
    }

    /* No photo for this colour: leave the gallery exactly as Shopify built it. */
    if (!wanted.length) {
      hidden = [];
    }

    var hiddenIds = {};
    for (var h = 0; h < hidden.length; h++) {
      hidden[h].hidden = true;
      hiddenIds[hidden[h].dataset.mediaId] = true;
    }
    for (var w = 0; w < wanted.length; w++) wanted[w].hidden = false;
    for (var a = 0; a < items.length; a++) {
      if (!hiddenIds[items[a].dataset.mediaId]) items[a].hidden = false;
    }

    var thumbs = gallery.querySelectorAll('.thumbnail-list__item');
    for (var n = 0; n < thumbs.length; n++) {
      thumbs[n].hidden = !!hiddenIds[thumbs[n].dataset.target];
    }

    /* Dawn's sliders count their pages on resize, so the counter and arrows
       stay wrong until one fires. */
    window.dispatchEvent(new Event('resize'));
  }

  function watch(section) {
    apply(section);

    section.addEventListener('change', function (event) {
      if (event.target.closest('variant-selects')) apply(section);
    });

    /* Dawn replaces the whole gallery with server-rendered HTML on a variant
       change, which throws away the hidden flags - so re-apply after it does. */
    var gallery = section.querySelector('media-gallery');
    if (!gallery || !window.MutationObserver) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(function () {
        pending = false;
        apply(section);
      });
    }).observe(gallery, { childList: true, subtree: true });
  }

  function init() {
    var sections = document.querySelectorAll('.section-main-product, [id^="MainProduct-"]');
    for (var i = 0; i < sections.length; i++) watch(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
